import PropTypes from 'prop-types';

export const scorePropType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
]);

export const liveMathsResultPropType = PropTypes.shape({
    id: PropTypes.number,
    level: PropTypes.number,
    topScore: scorePropType,
    questionsPerMinute: scorePropType,
    totalCorrect: scorePropType,
    accuracy: PropTypes.string
});



// WEBPACK FOOTER //
// ./containers/live-maths/student/student-prop-types.js